import { TWidget } from 'widgets/Widget';
import { isMediumViewAndUp } from 'widgets/toolbox/viewtype';

/**
 * @description FooterNewsletter implementation
 * @param Widget Base widget for extending
 * @returns FooterNewsletter class
 */
function FooterNewsletterClassCreator(Widget: TWidget) {
    class FooterNewsletter extends Widget {
        observer?: ResizeObserver;

        FOOTER_NL_HEIGHT_CSS_VAR = '--nl-content-height';

        prefs() {
            return {
                newsletterFormClass: 'b-newsletters-toggle_form',
                ...super.prefs()
            };
        }

        init() {
            this.checkHeadlineCopyHeight();
            this.initObserver();
        }

        /**
         * @description Observe footer height changes and emit an event
         */
        initObserver() {
            const footerNewsletter = this.ref('self').get();

            if (!footerNewsletter) {
                return;
            }

            if (this.observer) {
                this.destroy();
            }

            this.observer = new ResizeObserver(() => this.checkHeadlineCopyHeight());

            this.observer?.observe(footerNewsletter);
        }

        /**
         * @description Check newsletter content height and set CSS variable for footer newsletter content height
         */
        checkHeadlineCopyHeight() {
            const footerContent = this.ref('self').get()?.parentElement;

            if (isMediumViewAndUp()) {
                const newsletterContent = this.ref('footerNewsletterContent').get();
                const newsletterForm = newsletterContent?.getElementsByClassName(this.prefs().newsletterFormClass)[0] as HTMLElement | undefined;

                if (!newsletterContent || !newsletterForm || newsletterForm.classList?.contains('m-active')) {
                    return;
                }

                const newsletterContentHeight = newsletterContent.scrollHeight;

                footerContent?.style.setProperty(this.FOOTER_NL_HEIGHT_CSS_VAR, `${newsletterContentHeight}px`);
            } else {
                footerContent?.style.removeProperty(this.FOOTER_NL_HEIGHT_CSS_VAR);
            }
        }
    }

    return FooterNewsletter;
}

export type TFooterNewsletter = ReturnType<typeof FooterNewsletterClassCreator>;

export type TFooterNewsletterInstance = InstanceType<TFooterNewsletter>;

export default FooterNewsletterClassCreator;
